import { Image } from "@chakra-ui/react";
import React from "react";

interface Props {
  src: string;
  url: string;
}

export const PromotionBox = React.memo<Props>(({ src, url }) => {
  const openURL = React.useCallback(() => {
    window.open(url);
  }, [url]);

  return (
    <Image
      cursor="pointer"
      src={src}
      onClick={openURL}
      boxShadow="5px 5px 10px 0 rgba(0, 0, 0, 0.2)"
    />
  );
});
